import comingSoonBg from "@/assets/images/user/comingSoonBg.png";
import comingSoonLogo from "@/assets/images/user/comingSoonLogo.png";
import comingSoonText from "@/assets/images/user/comingSoonText.png";

export default function ComingSoon() {
    return (
        <div className="relative flex h-[200px] w-full flex-col items-center justify-center gap-[10px] overflow-hidden border border-[#7c65db] bg-[#F6F4FA] md:h-[320px]">
            <img
                src={comingSoonBg}
                alt="coming soon background"
                aria-hidden
                className="pointer-events-none absolute inset-0 z-[1] h-full w-full object-cover opacity-20"
            />
            <img src={comingSoonLogo} alt="GXG logo" className="z-[2] size-[60px] md:size-[120px]" />
            <div className="relative z-[2] flex flex-col items-center gap-[4px]">
                <img src={comingSoonText} alt="coming soon" className="h-[28px] md:h-[56px]" />
                <p className="font-['GongGothicMedium'] text-[16px] text-[#666] md:text-[24px]">추후 공개됩니다.</p>
            </div>
        </div>
    );
}
